export type SocialPlacement = MetaPlacement | TiktokPlacement | PinterestPlacement | SnapchatPlacement;

export enum MetaPlacement {
    Instagram = 'meta-instagram',
    Facebook = 'meta-facebook',
    Messenger = 'meta-messenger',
    FacebookReels = 'meta-facebookreels',
    InstagramReels = 'meta-instagramreels',
}

export enum TiktokPlacement {
    Default = 'tiktok-default',
    After9s = 'tiktok-after-9s',
    After9sWithCard = 'tiktok-after-9s-with-card'
}

export enum PinterestPlacement {
    BrowseImage = 'browse-image',
    BrowseVideo = 'browse-video',
    WatchVideo = 'watch-video'
}

export enum SocialNetworkType {
    Meta = 'meta',
    TikTok = 'tiktok',
    Pinterest = 'Pinterest',
    Snapchat = 'snapchat'
}

export enum SnapchatPlacement {
    Default = 'snapchat-default'
}

export interface ISocialPlacement {
    type: SocialPlacement;
    text: string;
    position: PlacementPostion;
}

export interface ISocialNetwork {
    type: SocialNetworkType;
    text: string;
    icon: string;
    placements: ISocialPlacement[];
    placementText?: string;
    ratios: string[];
}

export interface ISocialGuide {
    network: ISocialNetwork;
    placement: ISocialPlacement;
    overlay: boolean;
    guidelines: boolean;
}

export interface ICreativeSocialGuide {
    network: SocialNetworkType;
    placement: SocialPlacement;
    overlay: boolean;
    guidelines: boolean;
}

export interface PlacementPostion {
    top: number;
    bottom: number;
    left?: number;
    right?: number;
}

const DEFAULT_PLACEMENT_POSITION: PlacementPostion = { top: 0.14, bottom: 0.14 };

const META_PLACEMENTS: ISocialPlacement[] = [
    {
        type: MetaPlacement.Instagram,
        text: 'Instagram Story',
        position: DEFAULT_PLACEMENT_POSITION
    },
    {
        type: MetaPlacement.Facebook,
        text: 'Facebook Story',
        position: DEFAULT_PLACEMENT_POSITION
    },
    {
        type: MetaPlacement.Messenger,
        text: 'Messenger Story',
        position: DEFAULT_PLACEMENT_POSITION
    },
    {
        type: MetaPlacement.FacebookReels,
        text: 'Facebook Reels',
        position: { top: 0.12, bottom: 0.21, left: 0.07, right: 0.14 }
    },
    {
        type: MetaPlacement.InstagramReels,
        text: 'Instagram Reels',
        position: { top: 0.12, bottom: 0.21, left: 0.07, right: 0.13 }
    }
];

const TIKTOK_PLACEMENTS: ISocialPlacement[] = [
    {
        type: TiktokPlacement.Default,
        text: 'Default',
        position: { top: 0.11, bottom: 0.17, left: 0.11, right: 0.15 }
    },
    {
        type: TiktokPlacement.After9s,
        text: 'After 9s',
        position: { top: 0.11, bottom: 0.22, left: 0.11, right: 0.15 }
    },
    {
        type: TiktokPlacement.After9sWithCard,
        text: 'After 9s with card',
        position: { top: 0.11, bottom: 0.25, left: 0.11, right: 0.15 }
    },
];

const PINTEREST_PLACEMENTS: ISocialPlacement[] = [
    {
        type: PinterestPlacement.BrowseImage,
        text: '"Browse" Image',
        position: { top: 0.11, bottom: 0.252, left: 0.09, right: 0.092 }
    },
    {
        type: PinterestPlacement.BrowseVideo,
        text: '"Browse" Video',
        position: { top: 0.11, bottom: 0.252, left: 0.09, right: 0.092 }
    },
    {
        type: PinterestPlacement.WatchVideo,
        text: '"Watch" Video',
        position: { top: 0.10, bottom: 0.24, left: 0.0245, right: 0.115 }
    },
];


const SNAPCHAT_PLACEMENTS: ISocialPlacement[] = [
    {
        type: SnapchatPlacement.Default,
        text: 'Default',
        position: { top: 0.16, bottom: 0.084, left: 0.11, right: 0.09 }
    }
];

export const SOCIAL_PLACEMENTS: ISocialPlacement[] = [
    ...META_PLACEMENTS,
    ...TIKTOK_PLACEMENTS,
    ...SNAPCHAT_PLACEMENTS,
    ...PINTEREST_PLACEMENTS
];

export const SOCIAL_NETWORKS: ISocialNetwork[] = [
    {
        type: SocialNetworkType.Meta,
        text: 'Meta',
        icon: 'meta',
        placementText: 'Placement',
        placements: META_PLACEMENTS,
        ratios: ['9:16']
    },
    {
        type: SocialNetworkType.TikTok,
        text: 'TikTok',
        icon: 'tiktok',
        placementText: 'CTA Style',
        placements: TIKTOK_PLACEMENTS,
        ratios: ['9:16']
    },
    {
        type: SocialNetworkType.Pinterest,
        text: 'Pinterest',
        icon: 'pinterest',
        placementText: 'Placement',
        placements: PINTEREST_PLACEMENTS,
        ratios: ['9:16']
    },
    {
        type: SocialNetworkType.Snapchat,
        text: 'Snapchat',
        icon: 'snapchat',
        placements: SNAPCHAT_PLACEMENTS,
        ratios: ['9:16']
    }
];
